import { combineReducers } from 'redux-immutable';
import ClientsReducer from './Clients';
import ProfilePlanningReducer from './ProfilePlanning';
import GeneratedWeeksReducer from './GeneratedWeeks';
import UIReducer from '../UIState';
import FreelancersReducer from './Freelancers';
import UsersReducer from './Users';
import PortalAddressesReducer from './PortalAddresses';
import PortalUsersReducer from './PortalUsers';
import RedBookEntriesReducer from './RedBookEntries';

export default combineReducers({
    clients: ClientsReducer,
    profileplanning: ProfilePlanningReducer,
    generatedweeks: GeneratedWeeksReducer,
    freelancers: FreelancersReducer,
    ui: UIReducer,
    users: UsersReducer,
    portaladdresses: PortalAddressesReducer,
    portalusers: PortalUsersReducer,
    redbook: RedBookEntriesReducer
})